import { Box, Switch, VStack } from '@chakra-ui/react';
import { SettingsCard, SettingsRow } from '../../../../components/settings/primitives';
import InvoiceInboxAddressesTable from '../../../../components/invoice/InvoiceInboxAddressesTable';
import { useInvoicingDraft } from './shared';
import type { InvoicingSectionProps } from './types';

const EmailForwardingSection = ({ data }: InvoicingSectionProps) => {
    const { invoicing, updateInvoicing, isSaving } = useInvoicingDraft(data);

    const emailInvoicingOptIn = invoicing.emailInvoicingOptIn ?? false;
    const invoiceInboxAddresses = invoicing.invoiceInboxAddresses;

    const handleOptInChange = (isEnabled: boolean) => {
        if (!isEnabled) {
            updateInvoicing({
                emailInvoicingOptIn: false,
                invoiceInboxBaseLocalPart: undefined,
                invoiceInboxAddresses: undefined,
            });
            return;
        }
        updateInvoicing({ emailInvoicingOptIn: true });
    };

    return (
        <VStack spacing={6} align="stretch" pb={16}>
            <SettingsCard title="Invoice inbox">
                <SettingsRow
                    label="Enable invoice inbox"
                    description="Forward vendor invoice emails to the typed inbox addresses below. Each address creates uploads for one invoice type. Bulk addresses treat each attachment as its own invoice."
                    control={
                        <Switch
                            size="lg"
                            isChecked={emailInvoicingOptIn}
                            onChange={(e) => handleOptInChange(e.target.checked)}
                            colorScheme="partbay-blue"
                            isDisabled={isSaving}
                        />
                    }
                />
                {emailInvoicingOptIn && invoiceInboxAddresses && (
                    <Box py={4}>
                        <InvoiceInboxAddressesTable addresses={invoiceInboxAddresses} />
                    </Box>
                )}
            </SettingsCard>
        </VStack>
    );
};

export default EmailForwardingSection;
